import BackgroundImage from 'gatsby-background-image'
import styled from "@emotion/styled"

export const HeroSection = styled(BackgroundImage)`
height: 100vh;
display: flex;
align-items: center;
`
export const BannerSubtitle1Container = styled.p`
font-size: 14px;
    position: relative;
    color: #fff;
    font-family: PlayfairDisplay-Regular;
    line-height: normal;
    margin: 0;

    @media(min-width: 992px){
        font-size: 40px;
    }
`
export const BannerTitleContainer = styled.h3`
padding: 0;
    margin-right: auto;
    font-size: 29px;
    margin: 8px 0;
    text-align: center;
    font-weight: 700;
    color: #fff;
    font-family: 'Playfair Display', serif;
    letter-spacing: 4px;
    @media(min-width: 992px){
        font-size: calc(72px + 48 * ((100vw - 992px) / 928));
    }
    @media(min-width: 1920px){
        font-size: 120px;
    }
    
`
export const BannerSubtitle2Container = styled(BannerSubtitle1Container)`
text-align: right;
color: #f1d1a2;
margin-bottom: 1rem;
`
export const Wrapper = styled.div`
flex: 0 0 75%;
max-width: 75%;
margin: 0 auto;
@media(min-width: 992px){
    flex: 0 0 50%;
    max-width: 50%;
}
`
export const Line = styled.span`
display: inline-block;
    width: 66px;
    height: 1px;
    background: #fff;
    margin-left: 10px;
    position: relative;
    top: -10px;
`
export const Line2 = styled(Line)`
background: #f1d1a2;
margin-right: 10px;
`